import { Action } from '@ngrx/store';
import { Project } from '../lead-generation/shared/models/Project';
import { ReportMetaData } from './report';

export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_FAILURE = 'GET_PROJECTS_FAILURE';

export const GET_REPORTS_META_DATA = 'GET_REPORTS_META_DATA';
export const GET_REPORTS_META_DATA_SUCCESS = 'GET_REPORTS_META_DATA_SUCCESS';
export const GET_REPORTS_META_DATA_FAILURE = 'GET_REPORTS_META_DATA_FAILURE';

export const GET_OVERALL_REPORTS_META_DATA = 'GET_OVERALL_REPORTS_META_DATA';
export const GET_OVERALL_REPORTS_META_DATA_SUCCESS = 'GET_OVERALL_REPORTS_META_DATA_SUCCESS';
export const GET_OVERALL_REPORTS_META_DATA_FAILURE = 'GET_OVERALL_REPORTS_META_DATA_FAILURE';

export class GetProjectsAction implements Action {
  readonly type = GET_PROJECTS;

  constructor() {}
}

export class GetProjectsFailureAction implements Action {
  readonly type = GET_PROJECTS_FAILURE;

  constructor(public payload: any) {}
}

export class GetProjectsSuccessAction implements Action {
  readonly type = GET_PROJECTS_SUCCESS;

  constructor(public payload: Project[]) {}
}

export class GetMetaDataAction implements Action {
  readonly type = GET_REPORTS_META_DATA;

  constructor() {}
}

export class GetMetaDataFailureAction implements Action {
  readonly type = GET_REPORTS_META_DATA_FAILURE;

  constructor(public payload: any) {}
}

export class GetMetaDataSuccessAction implements Action {
  readonly type = GET_REPORTS_META_DATA_SUCCESS;

  constructor(public payload: ReportMetaData) {}
}

export class GetOverallMetaDataAction implements Action {
  readonly type = GET_OVERALL_REPORTS_META_DATA;

  constructor() {}
}

export class GetOverallMetaDataFailureAction implements Action {
  readonly type = GET_OVERALL_REPORTS_META_DATA_FAILURE;

  constructor(public payload: any) {}
}

export class GetOverallMetaDataSuccessAction implements Action {
  readonly type = GET_OVERALL_REPORTS_META_DATA_SUCCESS;

  constructor(public payload: ReportMetaData) {}
}

export type ReportsAction =
  | GetProjectsAction
  | GetProjectsSuccessAction
  | GetProjectsFailureAction
  | GetMetaDataAction
  | GetMetaDataFailureAction
  | GetMetaDataSuccessAction
  | GetOverallMetaDataAction
  | GetOverallMetaDataFailureAction
  | GetOverallMetaDataSuccessAction;
